<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <help-text>
          <h3>
            Subscription Targets
          </h3>

          <p>
            This table displays the subscription targets for the portal. The targets relates to the
            subscriptions that are sold for the portal.
          </p>
        </help-text>
      </div>

      <div class="col-xs-18">
        <NewList
            label="Month"
            :targets="[{name: 'new', label: 'New', width: 4}, {name: 'renewal', label: 'Renewal', width: 4}, {name: 'accrued_new', label: 'Accrued New', width: 5}, {name: 'accrued_renewal', label: 'Accrued Renewal', width: 5}]"
            :endpoint="'/api/v2/portals/' + portal.id + '/targets'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NewList from '../../../../../components/Panels/Administration/Targets/NewList'

export default {
  components: {HelpText, LoadingContainer, NewList},

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal']
}
</script>
